var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayItem(_vm.item)
    ? _c(
        "li",
        [
          !_vm.hasChildren
            ? _c(
                "component",
                _vm._b(
                  {
                    class: _vm.itemClassNames,
                    staticStyle: { "box-shadow": "inset 0 0 0 1px white" },
                  },
                  "component",
                  _vm.getUrlAttr(_vm.item),
                  false
                ),
                [
                  _vm.item.icon
                    ? _c(
                        "span",
                        { staticClass: "text-gray-400" },
                        [
                          _c("Icon", {
                            staticClass:
                              "size-5 quickfix-primary-color-when-router-link-active",
                            attrs: { icon: _vm.iconName },
                          }),
                        ],
                        1
                      )
                    : _vm.item.avatar
                    ? _c("span", { staticClass: "text-gray-400" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.item.avatar.src,
                            alt: _vm.item.avatar.alt,
                            height: "24",
                            width: "24",
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: [
                        "flex-1",
                        _vm.item.labelClass && "text-gradient-orange",
                      ],
                    },
                    [_vm._v(_vm._s(_vm.$t(_vm.item.label)))]
                  ),
                  _vm._v(" "),
                  _vm.item.badge
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "d-inline-flex items-center font-medium rounded-md text-xs tw-px-1.5 tw-py-0.5 tw-gap-0.5 bg-gray-50 dark:bg-gray-400 dark:bg-opacity-10 dark:text-gray-400 ring-1 ring-inset ring-gray-500 dark:ring-gray-400 ring-opacity-25 dark:ring-opacity-25 text-gray-700",
                        },
                        [_vm._v("\n      " + _vm._s(_vm.item.badge) + "\n    ")]
                      )
                    : _vm._e(),
                ]
              )
            : _c("div", [
                _c(
                  "button",
                  {
                    class: [
                      "border-0 text-left bg-white",
                      _vm.itemClassNames,
                      _vm.hasActiveChild && _vm.itemClassNamesActive,
                    ],
                    on: {
                      click: function ($event) {
                        _vm.isOpen = !_vm.isOpen
                      },
                    },
                  },
                  [
                    _vm.item.icon
                      ? _c(
                          "span",
                          { staticClass: "text-gray-400" },
                          [
                            _c("Icon", {
                              staticClass: "size-5",
                              class: _vm.hasActiveChild && "text-primary-500",
                              attrs: { icon: _vm.iconName },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "flex-1" }, [
                      _vm._v(_vm._s(_vm.$t(_vm.item.label))),
                    ]),
                    _vm._v(" "),
                    _vm.item.badge
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "d-inline-flex items-center font-medium rounded-md text-xs tw-px-1.5 tw-py-0.5 tw-gap-0.5 bg-gray-50 dark:bg-gray-400 dark:bg-opacity-10 dark:text-gray-400 ring-1 ring-inset ring-gray-500 dark:ring-gray-400 ring-opacity-25 dark:ring-opacity-25 text-gray-700",
                          },
                          [
                            _vm._v(
                              "\n        " + _vm._s(_vm.item.badge) + "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "transform transition-transform duration-200",
                        class: _vm.isOpen && "rotate-90",
                        staticStyle: { "margin-inline-end": "-0.25rem" },
                      },
                      [
                        _c("Icon", {
                          staticClass: "size-5",
                          attrs: { icon: "material-symbols:chevron-right" },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "nav",
                  {
                    staticClass: "transition-wrapper",
                    class: _vm.isOpen && "transition-is-open",
                  },
                  [
                    _c("div", { staticClass: "transition-inner" }, [
                      _c(
                        "ul",
                        { staticClass: "list-unstyled pb-3" },
                        _vm._l(_vm.childrenList, function (child) {
                          return _c(
                            "li",
                            {
                              key: child.label,
                              staticClass: "text-sm leading-4",
                            },
                            [
                              _c(
                                "component",
                                _vm._b(
                                  {
                                    staticClass:
                                      "d-flex flex-1 tw-gap-2 tw-ps-10 tw-pe-2.5 tw-py-1.5 w-full text-sm leading-4 rounded-md hover:text-gray-900 hover:bg-gray-50",
                                    staticStyle: { "min-height": "29.5px" },
                                  },
                                  "component",
                                  _vm.getUrlAttr(child),
                                  false
                                ),
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t(child.label)) +
                                      "\n              "
                                  ),
                                  child.badge
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-inline-flex items-center font-medium rounded-md text-xs tw-px-1.5 tw-py-0.5 tw-gap-0.5 bg-gray-50 dark:bg-gray-400 dark:bg-opacity-10 dark:text-gray-400 ring-1 ring-inset ring-gray-500 dark:ring-gray-400 ring-opacity-25 dark:ring-opacity-25 text-gray-700",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(child.badge) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }